import { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  noScalesDetectedTooltipMessage: {
    description: 'Message indicating scale dropdown is disabled because no scales are detected',
    defaultMessage: 'No scales detected',
    id: 'epLpiw',
  },
  multiPackageTooltipMessage: {
    description: 'Message indicating scale dropdown is disabled because the user should use the Multi-package modal instead',
    defaultMessage: 'Use Multi-package Shipment modal',
    id: 'yXefCo',
  },
});

export const useIsReadWeightFromScaleDisabled = (workstationCount, packageCount) => {
  const intl = useIntl();

  return useMemo(() => {
    let disabledReason = null;

    // if no scales, show that reason over others
    if (workstationCount === 0) {
      disabledReason = intl.formatMessage(messages.noScalesDetectedTooltipMessage);
    } else if (packageCount > 1) {
      disabledReason = intl.formatMessage(messages.multiPackageTooltipMessage);
    }

    return { isDisabled: Boolean(disabledReason), disabledReason };
  }, [workstationCount, packageCount, intl]);
};
